var React = require('react');

function StarFilled (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"id":"Vector","d":"M14.4459 1.33198C14.6509 0.839208 15.349 0.839208 15.5539 1.33198L18.8267 9.20078C18.9131 9.40852 19.1085 9.55046 19.3328 9.56844L27.8279 10.2495C28.3599 10.2921 28.5755 10.956 28.1703 11.3032L21.6979 16.8475C21.5271 16.9938 21.4525 17.2235 21.5047 17.4424L23.4821 25.732C23.6059 26.2512 23.0411 26.6616 22.5857 26.3834L15.3127 21.941C15.1207 21.8238 14.8792 21.8238 14.6872 21.941L7.41424 26.3834C6.95878 26.6616 6.39404 26.2512 6.51786 25.732L8.49526 17.4424C8.54748 17.2235 8.47284 16.9938 8.30198 16.8475L1.82966 11.3032C1.42433 10.956 1.64005 10.2921 2.17204 10.2495L10.6671 9.56844C10.8913 9.55046 11.0867 9.40852 11.1731 9.20078L14.4459 1.33198Z","fill":"#001E63"})));
}

StarFilled.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = StarFilled;

StarFilled.default = StarFilled;
